import React from "react";

/**
 * Instabridge icon — refined V5.
 * viewBox 40×40, 2-unit inner padding, constant-radius (r=7.5) semicircle arches,
 * blue support line dropped 4 units below the arch feet for breathing room.
 * Every value is intentionally clean so it stays crisp from 16px to 512px.
 */
export const Logo = ({ className = "h-8 w-8", dark = false }) => {
  const bg = dark ? "#FFFFFF" : "#0A2540";
  const arch = dark ? "#0A2540" : "#FFFFFF";
  return (
    <svg viewBox="0 0 40 40" className={className} fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <rect x="2" y="2" width="36" height="36" rx="8" fill={bg} />
      {/* Two constant-radius (r=7.5) semicircle arches, horizontally offset for the double-arch identity */}
      <g fill="none" stroke={arch} strokeWidth="1.5" strokeLinecap="round">
        <path d="M 9 22 A 7.5 7.5 0 0 1 24 22" />
        <path d="M 16 22 A 7.5 7.5 0 0 1 31 22" />
      </g>
      {/* Blue support line — shorter and thinner than before, gap of 4 units below arch feet */}
      <line x1="9.5" y1="26" x2="30.5" y2="26" stroke="#0066FF" strokeWidth="1.2" strokeLinecap="round" />
    </svg>
  );
};

export const BrandMark = ({ inverted = false }) => (
  <div className="flex items-center gap-2.5" data-testid="brand-mark">
    <Logo dark={inverted} />
    <div className={`font-display text-lg font-semibold tracking-tight ${inverted ? "text-white" : "text-[#0A2540]"}`}>
      Instabridge
      <span className={`ml-1 font-light ${inverted ? "text-white/70" : "text-[#6B7280]"}`}>Funding</span>
    </div>
  </div>
);
